import React, { useEffect, useState } from 'react'
import { isEmpty, map, size, slice } from 'lodash'

import EventCard from './EventCard'
import {
  enableLoadMoreEventCards as enableLoadMore,
} from '../../configuration/configs'
import labels from '../../configuration/labels'

import '../../styles/scss/components/grid/event-cards.scss'

const CARDS_PER_PAGE = window.innerWidth >= 1440 ? 12 : 9;

const EventCards = ({ events }) => {
  const [numVisibleCards, setNumVisibleCards] = useState(CARDS_PER_PAGE)

  useEffect(() => {
    setNumVisibleCards(CARDS_PER_PAGE)
  }, [events])

  function onShowMoreCards() {
    setNumVisibleCards((value) => value + CARDS_PER_PAGE)
  }

  const visibleEvents = enableLoadMore ? slice(events, 0, numVisibleCards) : events
  const showLoadMore = enableLoadMore && numVisibleCards < size(events)

  return (
    <div className="events-container">
      {isEmpty(visibleEvents) ? (
        <span className="events-unavailable">{labels.eventCardsEventsUnavailable}</span>
      ) : (
        <div className="event-cards">
          {map(visibleEvents, (event, index) => (
            <EventCard key={index} event={event} />
          ))}
        </div>
      )}
      {showLoadMore && (
        <button className="load-more" onClick={onShowMoreCards}>
          {labels.eventCardsCtaLoadMore}
          <div className="load-more-arrow" />
        </button>
      )}
    </div>
  )
}

export default EventCards
